export default __webpack_public_path__ + "static/media/distribution2.5014092f.png";